/*eslint-disable*/
import React, { useState } from 'react'
import { Button, Icon, Modal, Header, Table } from 'semantic-ui-react';
import Axios from 'axios';
import APP_CONSTANTS from '../../../config/constants';
import moment from 'moment';

function BatteryRenderer(props) {
    const [Id, setId] = useState('')
    const [openBox, setopenBox] = useState(false)
    const [batteryData, setBatteryData] = useState([])
    const [batteryDate, setbatteryDate] = useState('')
    // console.log('>>>', props.frameworkComponentWrapper.agGridReact.props.rowData)
    let handleClose = () => {
        setopenBox(false)
    }

    let handleOpenEdit = (e) => {
        let mainData = props.data
        setId(mainData.id)
        let userId = localStorage.getItem('userId')
        let customerNo = localStorage.getItem('customerNo')

        Axios.get(`${APP_CONSTANTS.BASE_URL}masters/vehicleBatteryMapping/?customerNumber=${customerNo}&userId=${userId}&vehicleId=${mainData.id}`, {
            headers: {
                'Content-Type': 'application/json',
                "Authorization": localStorage.getItem('apiToken'),
                "Access-Control-Allow-Origin": "*" 
            }
        }).then((response => {
            // console.log(response.data.data)
            setBatteryData(response.data.resultSet)
            setopenBox(true)
            
        }))
        .catch(error => {
            setopenBox(true)
        })

        // setbatteryNo(mainData.battery)
        // setbatteryDate(mainData.batteryInstallationDate)
        // setopenBox(true)
    }
    return (
        <>
            <Button onClick={handleOpenEdit} basic size="mini" type="button" icon> <Icon name="battery half" color="orange" /></Button>

            <Modal
                open={openBox}
                onClose={handleClose}
                size="tiny"
            >
                <Header size="tiny" color="blue" className="labelName p-bold-600">Battery Details</Header>
                <Modal.Content>
                    <Table compact size="small">
                        <Table.Header>
                            <Table.Row>
                                <Table.HeaderCell className="labelName p-bold-600">Battery Sr. No.</Table.HeaderCell>
                                <Table.HeaderCell textAlign="right" className="labelName p-bold-600">Installation Date</Table.HeaderCell>
                            </Table.Row>
                        </Table.Header>
                        <Table.Body>
                            { batteryData.length > 0 ? 
                              batteryData.map((battery)=>
                                    <Table.Row>
                                        <Table.Cell>{battery.batterySerialNo}</Table.Cell>
                                        <Table.Cell textAlign="right" >{battery.batteryInstallationDate ? battery.batteryInstallationDate.split(" ")[0]: 'NA'}</Table.Cell>
                                    </Table.Row>
                              )
                               :
                            'No Record Found'
                            }
                        </Table.Body>
                    </Table>
                </Modal.Content>
                <Modal.Actions>
                    <Button primary size="mini" onClick={handleClose}>OK</Button>
                </Modal.Actions>
            </Modal>
        </>
    )
}

export default BatteryRenderer
